

import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../utils/config";

const GetAllCat = () => {
    const [parentCategories, setParentCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    let bearerToken = sessionStorage.getItem('jwt_token');
    const config = {

        headers: {
            'Authorization': `Bearer ${bearerToken}`,
            'Content-Type': 'application/json',


        }
    };
    // Fetch all parent categories
    useEffect(() => {
        const parentCategoriesUrl =
            `${API_BASE_URL}/wp-json/wp/v2/categories?parent=0`;

        axios
            .get(parentCategoriesUrl, config)
            .then((response) => {
                setParentCategories(response.data);
                console.log("resData=", response.data)
            })
            .catch((error) =>
                console.error("Error fetching parent categories:", error),
            );
        //


        // 
    }, []);

    // Fetch subcategories for a given parent category
    const fetchSubcategories = async (parentCategoryId) => {
        alert(parentCategoryId);
        try {
            const parentCategoryUrl = `${API_BASE_URL}/wp-json/wp/v2/categories?parent=${parentCategoryId}`;
            const response = await axios.get(parentCategoryUrl, config);
            setSubcategories(response.data);
            console.log("dfgdg= ", response.data);
        } catch (error) {
            console.error("Error fetching subcategories:", error);
        }
    };

    return (
        <div>
            <h2>Parent Categories:</h2>
            <ul>
                {parentCategories.map((parentCategory) => (
                    <li key={parentCategory.id}>
                        {console.log(parentCategory.id)}
                        <button onClick={() => fetchSubcategories(parentCategory.id)}>
                            {parentCategory.name}
                        </button>
                    </li>
                ))}
            </ul>

            {subcategories.length > 0 && (
                <div>
                    <h3>Subcategories:</h3>
                    <ul>
                        {subcategories.map((subcategory) => (
                            <li key={subcategory.id}>{subcategory.name}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default GetAllCat;
